import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import HeaderMenu from '../components/HeaderMenu';

const ConsentInformation : React.FC = () => {
    return (
        <IonPage>
            <HeaderMenu title="Consent information" />
            <IonContent class="ion-padding">
                <h1>Consent Info page</h1>
            </IonContent>            
        </IonPage>
    );
}

export default ConsentInformation;